export const deepcopy = <T>(item: T): T => {
    if (!item) return item;
    try {
        return JSON.parse(JSON.stringify(item));
    } catch (e) {
        console.error(e);
        console.error('Error while copying object: ', item);
        throw e;
    }
};

export const shallowCopy = <T>(obj: T): T => {
    if (typeof obj !== 'object') return obj;
    else if (Array.isArray(obj)) return [...obj] as T;
    else return obj;
};

export const removeEmptyFields = <T>(obj: T extends Record<string, any> ? T : never) => {
    if (!obj) return obj;
    const result = Object.keys(obj).reduce(
        (acc, key) => (obj[key] ? { ...acc, [key]: obj[key] } : acc),
        {} as T
    );
    return result;
};
